module.exports = __webpack_public_path__ + "static/bitcoin-41265f49002a2d570ea457b7f75c6e6c.png";